export function getPlatform() {
	const screenWidth = window.screen.width;
	if (screenWidth < 760) {
		return true;
	} else {
		return false
	}
}
